export const onGridPreDestroyedEvent = ({ gridName, onGridPreDestroyed, params }) => {
  if (onGridPreDestroyed) onGridPreDestroyed(params);
};